module.exports = __webpack_public_path__ + "static/data8-14983faf2b9c7743d06a25052859cae6.png";